// ScheduleTabs.js
import React, { useState } from 'react';
import { FaFileExcel } from "react-icons/fa";

import "../css/scheduleTimetable.css"; 
import "../css/scheduleTabs.css"; 

const ScheduleTabs = ({ lstDayTabs, dayId, handleDayChange, objType, setObjType,onDownloadExcel }) => {
    return (
        <div className='col-sm-12 padding-remove'>
            <div className='col-sm-3 padding-remove' style={{ border: '1px solid #d4d4d4' }}>
                {/* <div className="form-group col-md-12 padding-remove">
                    <div className="control-label col-md-12 col-sm-12 col-xs-12" style={{ display: "flex", alignItems: "center" }}>
                        <div className="radio" style={{ margin: "0 15px 0 0" }}>
                            <label>
                                <input
                                    type="radio"
                                    name="view"
                                    value={objType == 'C'}
                                    checked={objType == 'C'}
                                    onChange={() => setObjType('C')}
                                />
                                Class
                            </label>
                        </div>
                        <div className="radio" style={{ margin: "0 15px 0 0" }}>
                            <label>
                                <input
                                    type="radio"
                                    name="view"
                                    value={(objType == 'T')}
                                    checked={(objType == 'T')}
                                    onChange={() => setObjType('T')}
                                />
                                Teacher
                            </label>
                        </div>
                        <div className="radio" style={{ margin: "0 15px 0 0" }}>
                            <label>
                                <input
                                    type="radio"
                                    name="view"
                                    value={objType == 'F'}
                                    checked={objType == 'F'}
                                    onChange={() => setObjType('F')}
                                />
                                Facility
                            </label>
                        </div>
                    </div>
                </div> */}
                <div className="form-group col-md-12 padding-remove  schedeuleRadioButtonsWraps">
                    <div className="col-md-4 col-sm-4  schedeuleRadioButtons">
                        <input type="radio" checked={objType == 'C'} onChange={() => setObjType('C')} name="Class View" value={objType == 'C'} />
                        <label >Class</label>
                    </div>
                    <div className="col-md-4 col-sm-4  schedeuleRadioButtons">
                        <input type="radio" checked={objType == 'T'} onChange={() => setObjType('T')} name="Class View" value={objType == 'T'} />
                        <label >Teacher</label>
                    </div>
                    <div className="col-md-4 col-sm-4  schedeuleRadioButtons">
                        <input type="radio" checked={objType == 'F'} onChange={() => setObjType('F')} name="Class View" value={objType == 'F'} />
                        <label >Facility</label>
                    </div>
                </div>
            </div>
            <div className='col-sm-8 padding-remove text-right'>
                <div className="days-tabs">
                    {lstDayTabs.map(tab => (
                        <button
                            key={dayId}
                            className={dayId === tab.dayId ? "btn btn-primary day-tab active" : "btn btn-primary day-tab "}
                            onClick={() => handleDayChange(tab.dayId)}
                        >
                            {tab.day}
                        </button>
                    ))}
                </div>
            </div>
            <div className="col-sm-1 padding-remove text-right">
              <FaFileExcel
    style={{ color: '#1D6F42', cursor: 'pointer', fontSize: 18, marginTop: 8 }}
    title="Download Excel"
    onClick={onDownloadExcel}
/>

            </div>
        </div>
    );
};

export default ScheduleTabs;
